/**
 * Cookie Consent Configuration
 * 
 * When updating cookie policies, increment CURRENT_POLICY_VERSION
 * to trigger re-prompting for all users.
 */

export const CURRENT_POLICY_VERSION = '1.0';

export const COOKIE_CONSENT_KEY = 'cookie_consent';

export interface CookieConsent {
  analytics: boolean;
  marketing: boolean;
  timestamp: string;
  policyVersion: string;
}

export const DEFAULT_CONSENT: CookieConsent = {
  analytics: false,
  marketing: false,
  timestamp: new Date().toISOString(),
  policyVersion: CURRENT_POLICY_VERSION,
};

export const COOKIE_CATEGORIES = {
  analytics: {
    id: 'analytics',
    name: 'Analytiska cookies',
    description: 'Hjälper oss förstå hur besökare använder webbplatsen (Google Analytics, Microsoft Clarity, Meta Pixel)',
    services: ['Google Analytics', 'Microsoft Clarity', 'Meta Pixel'],
  },
  marketing: {
    id: 'marketing',
    name: 'Marknadsföringscookies',
    description: 'Används för att visa relevanta annonser och mäta annonseffektivitet (Meta Pixel)',
    services: ['Meta Pixel'],
  },
} as const;

export const COOKIE_BANNER_TEXT = {
  title: 'Vi använder cookies',
  description: 'Vi använder cookies för att förbättra din upplevelse, analysera trafik och visa relevanta annonser.',
  acceptAll: 'Godkänn alla',
  rejectNonEssential: 'Endast nödvändiga',
  customize: 'Hantera inställningar',
  privacyLink: 'Läs mer i vår integritetspolicy',
  savePreferences: 'Spara inställningar',
  preferencesTitle: 'Cookieinställningar',
  preferencesDescription: 'Välj vilka typer av cookies du vill tillåta. Nödvändiga cookies krävs för att webbplatsen ska fungera.',
  essentialCookies: 'Nödvändiga cookies',
  essentialDescription: 'Krävs för grundläggande funktioner som inloggning och säkerhet. Kan inte inaktiveras.',
} as const;
